// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Governance resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class GovernanceClient {
  constructor(private readonly http: HttpClient) {}

  /** List Promotion Candidates via the Inferrex API. */
  async listPromotionCandidates(options?: { limit?: number | undefined }): Promise<{ candidates: Record<string, unknown> }> {
    return this.http.get<{ candidates: Record<string, unknown> }>('/v1/admin/connector-library/candidates', options);
  }

  /** The authenticated tenant's data-sensitivity map: every connected field carrying PII / financial / health / credential data, classified by the shared field-sensitivity resolver. */
  async getTenantSensitivityMap(options?: { limit?: number | undefined }): Promise<{ fields: Record<string, unknown>; totals: Record<string, unknown>; fieldCount: number }> {
    return this.http.get<{ fields: Record<string, unknown>; totals: Record<string, unknown>; fieldCount: number }>('/v1/governance/sensitivity-map', options);
  }

  /** Detected provider API changes affecting the authenticated tenant's connected systems: what changed, how urgent it is, and whether Inferrex already applied the fix. */
  async getProviderChanges(options?: { limit?: number | undefined }): Promise<{ changes: Record<string, unknown>; changeCount: number }> {
    return this.http.get<{ changes: Record<string, unknown>; changeCount: number }>('/v1/governance/provider-changes', options);
  }

  /** Get Sensitivity Map via the Inferrex API. */
  async getSensitivityMap(options?: { limit?: number | undefined }): Promise<{ fields: Record<string, unknown>; totals: Record<string, unknown>; fieldCount: number }> {
    return this.http.get<{ fields: Record<string, unknown>; totals: Record<string, unknown>; fieldCount: number }>('/v1/admin/sensitivity-map', options);
  }

  /** Flag Promotion Candidate via the Inferrex API. */
  async flagPromotionCandidate(id: string, requestOptions?: RequestOptions): Promise<{ success: boolean; visibility: string }> {
    return this.http.post<{ success: boolean; visibility: string }>(`/v1/admin/connector-library/candidates/${id}/flag`, undefined, requestOptions);
  }

  /** Reject Promotion Candidate via the Inferrex API. */
  async rejectPromotionCandidate(id: string, requestOptions?: RequestOptions): Promise<{ success: boolean; visibility: string }> {
    return this.http.post<{ success: boolean; visibility: string }>(`/v1/admin/connector-library/candidates/${id}/reject`, undefined, requestOptions);
  }

  /** Promote Connector via the Inferrex API. */
  async promoteConnector(id: string, request: { providerKey?: string; category?: string; displayName?: string; documentationUrl?: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; providerKey: string; staged: boolean }> {
    return this.http.post<{ success: boolean; providerKey: string; staged: boolean }>(`/v1/admin/connector-library/candidates/${id}/promote`, request, requestOptions);
  }

  /** List Staging via the Inferrex API. */
  async listStaging(options?: { limit?: number | undefined }): Promise<{ staged: Record<string, unknown> }> {
    return this.http.get<{ staged: Record<string, unknown> }>('/v1/admin/connector-library/staging', options);
  }

  /** Reject Staged Contribution via the Inferrex API. */
  async rejectStagedContribution(id: string, request: { reviewNotes?: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; status: string }> {
    return this.http.post<{ success: boolean; status: string }>(`/v1/admin/connector-library/staging/${id}/reject`, request, requestOptions);
  }

  /** Cut Release via the Inferrex API. */
  async cutRelease(request: { version: string; stagingIds?: unknown; notes?: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; version: string; released: number }> {
    return this.http.post<{ success: boolean; version: string; released: number }>('/v1/admin/connector-library/releases', request, requestOptions);
  }

  /** Set Partner Status via the Inferrex API. */
  async setPartnerStatus(providerKey: string, request: { partnerStatus: string }, requestOptions?: RequestOptions): Promise<{ success: boolean; providerKey: string; partnerStatus: string }> {
    return this.http.post<{ success: boolean; providerKey: string; partnerStatus: string }>(`/v1/admin/connector-library/${providerKey}/partner-status`, request, requestOptions);
  }

  /** Deprecate Provider Version via the Inferrex API. */
  async deprecateProviderVersion(providerKey: string, version: string, requestOptions?: RequestOptions): Promise<{ success: boolean; providerKey: string; version: string }> {
    return this.http.post<{ success: boolean; providerKey: string; version: string }>(`/v1/admin/connector-library/${providerKey}/versions/${version}/deprecate`, undefined, requestOptions);
  }
}
